const getSourceMovies = (sourceMoviesByItemId, khMovies, compMovies, pyMovies, dieselMovies, cortecMovies, vistaMovies, marsxMovies) => {
    const cliMovieRelevantSourceMovies = {}

    if(sourceMoviesByItemId) {
        sourceMoviesByItemId.map(movieSource => {
            _.keys(movieSource).map(movieSourceKey => {
                const movieSourceMovieId = movieSource[movieSourceKey]
    
                if(movieSourceKey === 'Kinoheld') {
                    cliMovieRelevantSourceMovies[movieSourceMovieId] = khMovies[movieSourceMovieId]
                } else if(movieSourceKey === 'Compeso') {
                    cliMovieRelevantSourceMovies[movieSourceMovieId] = compMovies[movieSourceMovieId]
                } else if(movieSourceKey === 'DieselV2') {
                    cliMovieRelevantSourceMovies[movieSourceMovieId] = dieselMovies[movieSourceMovieId]
                } else if(movieSourceKey === 'Cortec') {
                    cliMovieRelevantSourceMovies[movieSourceMovieId] = cortecMovies[movieSourceMovieId]
                } else if(movieSourceKey === 'Vista') {
                    cliMovieRelevantSourceMovies[movieSourceMovieId] = vistaMovies[movieSourceMovieId]
                } else if(movieSourceKey === 'MarsX') {
                    cliMovieRelevantSourceMovies[movieSourceMovieId] = marsxMovies[movieSourceMovieId]
                } else {
                    cliMovieRelevantSourceMovies[movieSourceMovieId] = pyMovies[movieSourceMovieId]
                }
            })
        })
    }

    return cliMovieRelevantSourceMovies
}

export default getSourceMovies